import { combineReducers } from 'redux'
import crewSlice from './crew/crewSlice'
import jobsSlice from './jobs/jobsSlice'
import fetchBoothSlice from './config/fetchBoothSlice'

export default combineReducers({
    crew: crewSlice,
    jobs: jobsSlice,
    config: fetchBoothSlice,
})
